import { Store } from '../../types';

export const isNewCarSelector = (state: Store): boolean => {
	const isNewCar = !state.isFlex && !state.isOccasion;
	return isNewCar;
};
